import { makeAutoObservable, runInAction } from "mobx";

export default class toolFeatureStore {
  toolFeature = [];

  constructor() {
    makeAutoObservable(this);
  }

  setData = (data) => {
    this.toolFeature = [];
    runInAction(() => {
      this.toolFeature = data;
    });
  };

  deleteToolFeature = (id) => {
    let newState = this.toolFeature.filter((toolFeature) => toolFeature.id !== id);
    this.toolFeature = [];
    this.toolFeature = newState;
  };
}